//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            02nd October 2018
//  * @type            Login Component File
//  * @description -   This file renders the html and functionality for logging into the app.
<template>
    <v-wait for="logging in">
        <template slot="waiting">
            <div id="loadingDiv" class="loadingDiv_analytics">
                <div class="loadersec">
                    <div class="loader"></div>
                </div>
            </div>
        </template>
        <div class="wrapper login" v-if="!ssoStatus" :style="{ display: ssoStatus ? 'none' : 'block' }">
            <div class="login-modal" >
                <div class="left-side">         
                    <div class="login_box">
                        <div class="w-100">
                            <div class="text-center">
                                <a href class="logo-fn main-bg">
                                    <img :src="logoImage" alt="Logo" @error="imageUrlAlt" />
                                </a>
                                <h3 class="modal-head">Sign In</h3>
                            </div>
                            <div v-if="domain ? (domain.length <= 0 || domain === 'www') : 1">
                                <form @submit.prevent="verifyAccount">
                                    <div
                                        v-if="domain ? (domain.length <= 0 || domain === 'www') : 1"
                                        class="input_box input-group form-group"
                                        v-bind:class="[isActive3 ? 'focus_input' : '']">
                                        <input
                                            v-model="account"
                                            @change="addClass3"
                                            id="inputAccount"
                                            type="text"
                                            class="form-control input_focus"
                                            placeholder="Account Name"
                                            required
                                            autofocus />
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                              <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m482.284 482h-39.573v-467c0-8.284-6.716-15-15-15h-343.423c-8.284 0-15 6.716-15 15v467h-39.572c-8.284 0-15 6.716-15 15s6.716 15 15 15h452.569c8.284 0 15-6.716 15-15s-6.716-15-15.001-15zm-277.415 0v-102.261h102.261v102.261zm132.261 0v-117.261c0-8.284-6.716-15-15-15h-132.261c-8.284 0-15 6.716-15 15v117.261h-75.581v-452h313.423v452z"/><path d="m223.748 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/><path d="m361.76 66.309h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/><path d="m223.748 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/><path d="m361.76 205.954h-73.508c-8.284 0-15 6.716-15 15v73.508c0 8.284 6.716 15 15 15h73.508c8.284 0 15-6.716 15-15v-73.508c0-8.284-6.716-15-15-15zm-15 73.508h-43.508v-43.508h43.508z"/></g></svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group login_btn_div">
                                        <button type="submit" class="login_btn">LOG IN</button>
                                    </div>
                                    <div
                                        :class="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.' ? 'alert alert-warning login-warn' : 'alert alert-danger'"
                                        v-if="error" >
                                        <i
                                            v-if="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.'"
                                            class="fa fa-exclamation-triangle"
                                            aria-hidden="true"
                                        ></i>
                                        {{ error }}
                                        <span v-if="errorSupport">
                                            <a
                                            href="javascript:void(0)"
                                            id="btnViewSupportModal"
                                            @click="$refs.supportModal.show()"
                                            >Support Team</a>
                                        </span>
                                    </div>
                                    <div v-if="verificationLink" class="alert alert-danger">This Account is inactive. <a href="javascript:void(0)" @click="resendVerificationEmail" style="text-decoration: underline;">Resend Activation email.</a></div>
                                </form>
                                <div class="row">
                                    <div class="col-12 text-right">
                                        <router-link :to="{ name : 'ForgotPassword', path : '/forgot-pswd', params: { siteDefaultTitle: this.siteTitle } }" class="f-password">Forgot Password?</router-link>
                                    </div>
                                </div>
                            </div> 
                            <div v-else>
                                <form @submit.prevent="login">
                                    <div class="input_box input-group form-group" v-bind:class="[isActive1 ? 'focus_input' : '']">
                                        <input
                                        v-model="email"
                                        @change="addClass1"
                                        id="inputEmail"
                                        type="text"
                                        class="form-control input_focus"
                                        placeholder="Email or Username"
                                        required
                                        autofocus
                                        />
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <i class="fa fa-user-o" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="input_box input-group form-group" v-bind:class="[isActive2 ? 'focus_input' : '']">
                                        <input
                                        v-model="password"
                                        @change="addClass2"
                                        id="inputPassword"
                                        type="password"
                                        class="form-control input_focus"
                                        placeholder="Password"
                                        required
                                        />
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                  viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                                  <g>
                                                    <g>
                                                      <path d="M330.704,170.667H95.963C78.405,170.667,64,184.951,64,202.572v192.19c0,17.593,14.31,31.905,31.963,31.905h234.742
                                                        c17.557,0,31.963-14.284,31.963-31.905v-192.19C362.667,184.979,348.357,170.667,330.704,170.667z M320,384H106.667V213.333H320
                                                        V384z"/>
                                                    </g>
                                                  </g>
                                                  <g>
                                                    <g>
                                                      <path d="M217.082,0h-7.498c-56.815,0-102.918,46.172-102.918,102.978v81.645h42.667v-81.645c0-33.256,27.014-60.311,60.251-60.311
                                                        h7.498c33.22,0,60.251,27.032,60.251,60.311v81.645H320v-81.645C320,46.134,273.866,0,217.082,0z"/>
                                                    </g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                  <g>
                                                  </g>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        :class="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.' ? 'alert alert-warning login-warn' : 'alert alert-danger'"
                                        v-if="error"
                                        >
                                        <i
                                            v-if="error === 'Invalid username or password! Your account will be locked after 5 failed login attempts.'"
                                            class="fa fa-exclamation-triangle"
                                            aria-hidden="true"
                                        ></i>
                                        {{ error }}
                                        <span v-if="errorSupport">
                                            <a
                                            href="javascript:void(0)"
                                            id="btnViewSupportModal"
                                            @click="$refs.supportModal.show()"
                                            >Support Team</a>
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <button type="submit" class="login_btn">LOG IN</button>
                                    </div>
                                </form>
                                <div class="row">
                                    <div class="col-12 text-right">
                                        <router-link :to="{ name : 'ForgotPassword', path : '/forgot-pswd', params: { siteDefaultTitle: this.siteTitle } }" class="f-password">Forgot Password?</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="join-us">
                    <span class="">Don't have an account yet?<a :href="signupUrl" target="_blank">Join Tapapp</a></span>
                </div>
            </div>
            <div class="rulesAndRegulation">
              <a
                  href="https://tapapp.cloud/terms-and-conditions"
                  target="_blank"
                  class="linkTermsandConditions"
                  id="linkTermsandConditions"
                  rel="noopener noreferrer"
              >Terms and Conditions</a>
              <span class="tandcpipe">|</span>
              <a
                  href="https://tapapp.cloud/privacy-policy"
                  target="_blank"
                  class="linkPrivacyPolicy"
                  id="linkPrivacyPolicy"
                  rel="noopener noreferrer"
              >Privacy Policy</a>
              <span class="tandcpipe">|</span>
              <a
                  href="https://tapapp.cloud/request-demo "
                  target="_blank"
                  class=""
                  id=""
                  rel="noopener noreferrer"
              >Demo</a>
              <span class="tandcpipe">|</span>

              <!-- id="btnViewSupportModal"
                  @click="$refs.supportModal.show()" -->
              <a href="https://tapapp.cloud/support" target="_blank" rel="noopener noreferrer">Support</a>
          </div>
          <div class="version">Version: {{currentVersion}}</div>
        </div>
        <div v-if="ssoStatus">
            <div id="loadingDiv" class="loadingDiv_analytics">
                <div class="loadersec">
                    <div class="loader"></div>
                </div>
            </div>
        </div>
        <b-modal ref="tncModal" id="tncModal" title="Terms of Use" size="xl" hide-footer>
            <div class>
            <div class="col-lg-12 col-xs-12 form-group">
                <div class="textBreakWord" id="emailMessage" v-if="dialogsData.tncDetails">
                <editor
                    disabled
                    key="editor1"
                    api-key="2rte5mnmqjdh47k3qtp100stegm271pdrlkibebj4izwt6m4"
                    v-model="dialogsData.tncDetails.st_message"
                    :init="{

                    relative_urls: false,
                        remove_script_host: false,
                        convert_urls: false,
                        selector: '#txtPolicyDescription',
                        height: 250,
                        theme: 'modern',
                        menubar: false,
                        statusbar: false,
                        toolbar: false,
                        forced_root_block: '', //this is use for remove top space Added by Rajesh Rathod 10-07-2018
                        readonly: true,
                    }"
                ></editor>
                </div>
            </div>
            </div>
            <div class="modal-footer" v-if="dialogsData.tncDetails">
            <span
                class="pull-left"
                style="color: #9f9f9f;"
            >Last Updated: {{dialogsData.tncDetails.dt_added_at}}</span>
            <div class="cl-submit-btn pull-right">
                <button class="btn btn-ok" @click="$refs['tncModal'].hide()">OK</button>
            </div>
            </div>
        </b-modal>
        <b-modal ref="privacyModal" id="privacyModal" title="Privacy Policy" hide-footer>
            <div class="modal-body">
            <div class>
                <div class="col-lg-12 col-xs-12 form-group">
                <div class="textBreakWord" id="emailMessage" v-if="dialogsData.privacyDetails">
                    <editor
                    disabled
                    key="editor1"
                    api-key="2rte5mnmqjdh47k3qtp100stegm271pdrlkibebj4izwt6m4"
                    v-model="dialogsData.privacyDetails.st_message"
                    :init="{

                    relative_urls: false,
                        remove_script_host: false,
                        convert_urls: false,
                        selector: '#txtPolicyDescription',
                        height: 250,
                        theme: 'modern',
                        menubar: false,
                        statusbar: false,
                        toolbar: false,
                        forced_root_block: '', //this is use for remove top space
                        readonly: true,
                    }"
                    ></editor>
                </div>
                </div>
            </div>
            </div>
            <div class="modal-footer" v-if="dialogsData.privacyDetails">
            <span
                class="pull-left"
                style="color: #9f9f9f;"
            >Last Updated: {{dialogsData.privacyDetails.dt_added_at}}</span>

            <div class="cl-submit-btn pull-right">
                <button class="btn btn-ok" @click="$refs['privacyModal'].hide()">OK</button>
            </div>
            </div>
        </b-modal>
        <b-modal ref="supportModal" id="supportModal" hide-footer>
            <template slot="modal-header">
            <h4 class="modal-title">
                <b>Contact us</b>
            </h4>
            <div
                class="row"
                v-if="dialogsData.in_support_email_status || dialogsData.st_site_support_telephone"
            >
                <div class="col-md-5">
                <h4 class="contact-us-detail" v-if="dialogsData.in_telephone_status">
                    <i class="fa fa-phone marginR10"></i>
                    {{dialogsData.st_site_support_telephone}}
                </h4>
                </div>
                <div
                class="col-md-7"
                
                >
                <h4 class="contact-us-detail" v-if="dialogsData.in_support_email_status">
                    <i class="fa fa-at marginR10"></i>
                    {{dialogsData.st_site_support_email}}
                </h4>
                </div>
            </div>

            <div class="custom-modal-header-close" slot="modal-header-close">
                <button
                type="button"
                class="close"
                @click="$refs['supportModal'].hide()"
                aria-label="Close"
                >
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            </template>
            <div class="row session-exp-container">
            <form name="frmAddEditSupport" id="frmAddEditSupport" v-on:submit.prevent>
                <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                    <p>
                    Send us a support request. For technical support, issues or feedback,
                    please fill in this form and we'd be happy to assist.
                    </p>
                </div>
                </div>
                <div class="row marginB10">
                <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="form-group form-group-new">
                
                    <div class="col-sm-12">
                        <label class="control-label" for="email">Email Address</label> 
                        <input
                        type="text"
                        name="txtUserSupportEmail"
                        v-model="txtUserSupportEmail"
                        class="form-control support-mail"
                        id="email"
                        v-validate="'required|email'"
                        data-vv-as="above"
                        />
                        <span
                        class="error"
                        v-if="errors.has('txtUserSupportEmail')"
                        >{{ errors.first('txtUserSupportEmail') }}</span>
                    </div>
                    </div>
                </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 marginB10">
                <div class="form-group">
                    <textarea
                    v-model="txtSupportMessage"
                    name="txtSupportMessage"
                    rows="9"
                    id="txtSupportMessage"
                    class="form-control"
                    v-validate="'required'"
                    data-vv-as="above"
                    ></textarea>
                    <span
                    class="error"
                    v-if="errors.has('txtSupportMessage')"
                    >{{ errors.first('txtSupportMessage') }}</span>
                </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 marginB10">
                <div class="form-group">
                    <vue-dropzone
                    ref="txtSupportFile"
                    :options="dropzoneOptions"
                    :include-styling="false"
                    :useCustomSlot="true"
                    id="supportDropzone"
                    >
                    <!-- <div class="dropzone-custom-content">
                        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                        <div class="subtitle">...or click to select a file from your computer</div>
                    </div>-->
                    <div
                        class="dropzone drop-box needsclick dz-clickable marginLR0 width100"
                        id="supportFileAttachment"
                    >
                        <div class="dz-message needsclick">
                        <span>
                            Drop files to upload, or
                            <button
                            class="btn-ok-support support-fileinput-button"
                            type="button"
                            >browse</button>
                        </span>
                        </div>
                        <ul class="files" id="supportPreviews"></ul>
                    </div>
                    </vue-dropzone>
                </div>
                </div>
            </form>
            </div>

            <div class="survey_settings row">
            <div class="col-md-12">
                <div class="cl-submit-btn pull-right">
                <button
                    @click="$refs['supportModal'].hide()"
                    class="btn btn-cancel"
                    aria-label="Close"
                >Cancel</button>
                <button
                    @click.prevent="sendSupport"
                    class="btn btn-ok"
                    id="btnSendSupportRequest"
                >Send</button>
                </div>
            </div>
            </div>
        </b-modal>
    </v-wait>
</template>

<script>
var supportFormData = new FormData();
// import styles from '../assets/css/bootstrap.min.css'
// import style from '../assets/css/sidebar.css'
// import('../assets/js/popper.min.js')
// import('../assets/js/bootstrap.min.js')
// import('../assets/js/holder.min.js')
// import('../assets/js/jquery-3.3.1.slim.min.js')
// import('../assets/js/jscolor.js')
// import('../assets/js/jquery-2.0.3.min.js')
// import('../assets/js/jquery.uploadPreview.min.js')
var Editor = require("@tinymce/tinymce-vue").default;

var { frontHostName, redirectUrl, signupUrl, defaultWhiteLabel, currentVersion, encrypted_key } = require("../../config/config.js");
import CryptoJS from "crypto-js";

export default {
  name: "LoginNew",
  components: {
    Editor
  },
  metaInfo() {
    return {
      title: "Login" + this.siteTitle,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Login to your Tapapp account - the most powerful, secure, and cost-effective way to automate data collection. Perfect for audits, inspections or checklists."
        }
      ]
    };
  },
  data() {
    return {
      email: "",
      password: "",
      account: "",
      error: false,
      isActive1: 0,
      isActive2: 0,
      isActive3: 0,
      logoImage: require("../assets/images/tapapp_logo.png"),
      dialogsData: [],
      txtUserSupportEmail: "",
      txtSupportMessage: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        acceptedFiles: ".jpeg, .jpg, .png, .gif",
        maxFilesize: 2,
        maxFiles: 5,
        addRemoveLinks: false,
        parallelUploads: 100,
        previewTemplate: this.previewTemplate(),
        previewsContainer: "#supportPreviews", // Define the container to display the previews
        clickable: ".support-fileinput-button" // Define the element that should be used as click trigger to select files.
      },
      currentVersion: currentVersion,
      errorSupport: false,
      signupUrl: '',
      verificationLink : false,
      siteTitle: '',
      siteDefaultTitle: '',
      subscriberid: '',
      isSso:false,
      ssoStatus:false,
    };
  },
  props: ["domain", "whitelabel"],
  async mounted() {
    console.log("in mounted");
    console.log(this.domain);
    this.signupUrl = signupUrl;
    //var currentUrl = "https://subsys.hispecservices.com/default/login/sso/b1a59b315fc9a3002ce38bbe070ec3f5";
    var currentUrl = window.location.href;
    let url = process.env.API_PATH + "/getDomainDetails";

    await axios
      .post(
        url,
        {
          st_subdomain: this.domain,
          st_whitelabel: this.whitelabel
        },
        {
          headers: { "Content-Type": "application/json" }
        }
      )
      .then(response => {
        this.currentVersion = response.data.versionDetails.st_release_no;
        if (response.data.flag === 1) {
          this.subscriberid = response.data.data.in_subscription_id;
          this.setDomainDesign(response.data.data);
        } else if (response.data.flag === 4) {
          console.log("invalid account name");
          this.$awn.alert("The page you requested does not exists.");
          var loc = location.host;
          var locArr = loc.split(".");
          loc = location.protocol + "//" + locArr[1] + "." + locArr[2];
          window.location.href = loc;
        } else {
          console.log("invalid url");
          this.$awn.alert("The page you requested does not exists.");
          window.location.href = redirectUrl;
          // this.$router.push({
          //   name: "ErrorPage"
          // });
        }
      })
      .catch();
    if(currentUrl.includes("sso"))
    {
      let url = process.env.API_PATH + "/getSubscriberDetailsSSO";

      await axios
        .post(
          url,
          {
            subscriptionId: this.subscriberid,
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          this.email = response.data.data[0].st_user_name;
          this.password = response.data.data[0].st_normal_password;
          this.account = response.data.data.domain;
          this.isSso=true;
          this.login();
        });
      }else{
      this.isSso=false;
      }
      //loader check
      if(currentUrl.includes("sso") && this.isSso == true)
      {
        this.ssoStatus=true;
      }else{
        this.ssoStatus=false;
      }
  },
  methods: {
    setDomainDesign(designdata) {
      console.log('Design Data == ',designdata,'-----',window.location.href);
      console.log('domain == ',this.domain);
      console.log('whitelabel == ',this.whitelabel);
      this.siteTitle = ((designdata.st_default_site_name) ? (this.domain == 'www' ? '' : ' - ' + this.domain) + ((this.whitelabel && this.whitelabel != 'default') ? (': ' + this.whitelabel + ' - ' + designdata.st_site_name) : '') + ' - ' + designdata.st_default_site_name : '');
      this.siteDefaultTitle = designdata.st_default_site_name;
      // Updating favicon according to whitelabel details
      if (designdata.favicon_image_url && designdata.favicon_image_url.length > 0) {
        const favicon = document.getElementById("favicon");
        favicon.href = designdata.favicon_image_url;
      }
      if (this.whitelabel === "") {
        console.log("set default whitelabel");

        this.$router.push({
          name: "LabelLogin",
          params: {
            domain: this.domain,
            whitelabel: designdata.st_subdomain_name
          }
        });
      } else if (designdata.st_subdomain_name != this.whitelabel) {
        console.log("invalid whitelabel");
        this.$router.push({
          name: "LabelLogin",
          params: {
            domain: this.domain,
            whitelabel: designdata.st_subdomain_name
          }
        });
        // router.replace({ name: 'Login', params: { domain, whitelabel } })
      }
      this.account =
        this.domain.length > 0 && this.domain != "www" ? this.domain : "";
      this.isActive3 = 1;
      const customStyle = document.querySelector("body");
      customStyle.style.setProperty(
        "--headerColor",
        "#" + designdata.st_header_color
      );
      customStyle.style.setProperty(
        "--headerTextColor",
        "#" + designdata.st_header_text_color
      );
      customStyle.style.setProperty(
        "--buttonLinkColor",
        "#" + designdata.st_button_link_color
      );
      customStyle.style.setProperty(
        "--buttonTextColor",
        "#" + designdata.st_button_text_color
      );
      this.dialogsData = designdata;
      // Updating logo according to whitelabel details
      if (designdata.st_logo_image && designdata.st_logo_image.length > 0) {
        this.logoImage =
          frontHostName +
          process.env.CAKE_BASE_PATH +
          "img/whitelabel/" +
          designdata.st_logo_image;
      }
    },
    onAdded(file, index) {
      supportFormData.append("supportFileAttachment[]", file);
      console.log(file);
    },
    showSupport(){
        this.resetSupportData();
        this.$refs.supportModal.show();
    },
    resetSupportData(){
        this.txtUserSupportEmail = "";
        this.txtSupportMessage = "";
        this.$refs.txtSupportFile.removeAllFiles();
        this.errors.clear();
        this.$nextTick(() => {
            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });
        });
    },
    async sendSupport() {
        this.$validator.validateAll().then(async result => {
        if (result) {
          let url = process.env.API_PATH + "/sendSupportMail";
          console.log(this.$refs.txtSupportFile.dropzone.files);
          let files = this.$refs.txtSupportFile.dropzone.files;
          let formData = new FormData();

          // if you want to upload multiple files at once loop
          // through the array of files
          for (let i = 0; i < files.length; i++) {
            formData.append("supportFileAttachment[]", files[i]);
          }
          formData.append("txtUserSupportEmail", this.txtUserSupportEmail);
          formData.append("txtSupportMessage", this.txtSupportMessage);
          await axios
            .post(url, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              if (response.data.data.FLAG === 1) {
                  this.$awn.success(response.data.data.MSG);
                    this.$refs.supportModal.hide();
                console.log(response);
              }else{
                  this.$awn.success('Something might wrong. Try later');
              }
            })
            .catch();
        }
      });
    },
    addClass1() {
      if (this.email !== "") {
        this.isActive1 = 1;
      } else {
        this.isActive1 = 0;
      }
    },
    addClass2() {
      if (this.password !== " ") {
        this.isActive2 = 1;
      } else {
        this.isActive2 = 0;
      }
    },
    addClass3() {
      if (this.account !== "") {
        this.isActive3 = 1;
      } else {
        this.isActive3 = 0;
      }
    },
    async login() {
      this.$wait.start("logging in");
      this.errorSupport = false;
      let url = process.env.API_PATH + "/newLogin";
      let formData = {
        txtEmail: this.email,
        txtPassword: this.password,
        txtAccount: this.account,
        txtWhiteLabel: this.whitelabel,
        requestType: "online",
        isSso:this.isSso
      };
      let requestData = JSON.stringify(formData);
      const key = CryptoJS.enc.Hex.parse(encrypted_key);
      const ivs = CryptoJS.lib.WordArray.random(16);
      var encrypted = CryptoJS.AES.encrypt(requestData, key, {
          iv: ivs,
          padding: CryptoJS.pad.ZeroPadding,
      });
      var response_data = encrypted.toString();
      await axios
        .post(
          url,
          {
            request_data: response_data,
            v: encrypted.iv.toString(),
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(request => this.loginSuccessful(request))
        .catch(() => this.loginFailed());
    },
    loginSuccessful(req) {
      const keys = CryptoJS.enc.Hex.parse(encrypted_key);
      var encryptedResponse = req.data.response_data;
      var resIv = CryptoJS.enc.Hex.parse(req.data.v);
      var decrypted = CryptoJS.AES.decrypt(encryptedResponse, keys, {
        iv : resIv,
        padding: CryptoJS.pad.ZeroPadding,
      });
      var response_datas = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      req.data = response_datas;
      if (!req.data.flag) {
        this.loginFailed(req);
        return;
      }
      // localStorage.setItem("user", JSON.stringify(req.data.data));
      this.$session.start();
      // this.$session.set("userDetails", req.data.data);
      this.$session.set("requestId", req.data.data.in_user_id);
      this.$session.set("jwt_token", req.data.token);
      this.$session.set("propertyname", req.data.data.st_user_name);
      this.$session.set("whitelabel", req.data.data.whitelabel);
      this.$session.set("user_permissions", req.data.user_permissions);
      this.$session.set("requestUserType", req.data.data.in_user_type);
      this.$session.set("subscriptionId", req.data.data.in_subscription_id);
      this.$cookies.set(
        req.data.cakeData.cakeCookieName,
        req.data.cakeData.cakeSessionId,
        "0",
        req.data.cakeData.cakeCookiePath
      );
      this.$session.set("lang", req.data.lang);
      this.$i18n.locale = this.$session.get("lang");
      this.$validator.localize(this.$session.get("lang"));

      // Set awesome notification labels in respective language
      this.$awn.options.labels.tip = this.$t("notificationLabels.tip");
      this.$awn.options.labels.info = this.$t("notificationLabels.info");
      this.$awn.options.labels.success = this.$t("notificationLabels.success");
      this.$awn.options.labels.warning = this.$t("notificationLabels.warning");
      this.$awn.options.labels.alert = this.$t("notificationLabels.alert");
      this.$awn.options.labels.async = this.$t("notificationLabels.async");
      this.$awn.options.labels.confirm = this.$t("notificationLabels.confirm");

      axios.defaults.headers.common["Authorization"] = this.$session.get(
        "jwt_token"
      );

      localStorage.token = req.data.flag;
      this.error = false;
       console.log("Location:", location);
      // window.location = 'http://192.168.1.100/hispec_report/code/dashboard/'
      let wlabel =
        this.whitelabel.length > 0 && this.whitelabel !== defaultWhiteLabel
          ? this.whitelabel
          : req.data.data.whitelabel;
      // var loc =
      //   "http://" +
      //   location.hostname +
      //   "/" +
      //   wlabel +
      //   process.env.CAKE_PATH;

      let redirection = '';
      if(this.$route.query.redirect_url == null)
      {
        redirection = (req.data.data.in_user_type == 1) ? process.env.CAKE_ADMIN_PATH : process.env.CAKE_PATH;
      }
      else
      {
        redirection = this.$route.query.redirect_url;
      }
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        wlabel +
        redirection;
      window.location.href = loc;
      // this.$router.replace(this.$route.query.redirect || '/dashboard')
    },
    loginFailed(req) {
     // console.log(req.data);
      this.$wait.end("logging in");

      if (req.data.msg == "accountInactive") {
        // this.errorSupport = true;
        // this.error = "Your account has been deactivated! Please contact our ";
        this.error = "Your account has been locked! Please contact your administrator.";
      } else {
      this.error = req.data.msg;
      }
      delete localStorage.token;
    },
    imageUrlAlt(event) {
      event.target.src = require("../assets/images/logo.png");
    },
    previewTemplate() {
      // // var previewNode = document.querySelector("#supportTemplate");
      // // console.log(previewNode);
      // // previewNode.id = "";
      // // var previewTemplate = previewNode.parentNode.innerHTML;
      // // previewNode.parentNode.removeChild(previewNode);
      // return previewTemplate;
      return `<li>
                <i class="fa fa-file-o"></i>
                <span><a class="dzjs-filename" data-dz-name></a></span>
                <a href="javascript:void(0);" class="scanning-spinner pull-right" style="display: none;"><i class="fa fa-spinner fa-spin"></i></a>
                <a href="javascript:void(0);" class="scanning-success pull-right" style="color: green; display: none;" data-toggle="tooltip" title="The file does not contain a virus."><i class="fa fa-check"></i></a>
                <a href="javascript:void(0);" class="scanning-error pull-right" style="color: red; display: none; width: 34px;" data-toggle="tooltip" title="The file contains a virus."><i class="fa fa-times"></i></a>
                <a href="javascript:void(0);" class="pull-right" style="cursor: pointer" title="Delete Attachment" data-dz-remove>
                    <i class="fa fa-trash" style="cursor: pointer"></i>
                </a>
                <div class="hidden dropzone-error-message" style="margin: 0 35px;">
                    <a href="#" class="text-danger" title="" data-dz-errormessage></a>
                </div>
            </li>`;
    },
    async verifyAccount(){
      this.verificationLink = false;
      this.error = false;
      let url = process.env.API_PATH + "/verifyAccount";
      await axios
        .post(
          url,
          {
            txtAccount: this.account,
            requestType: "online"
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          //console.log('Response -- ',response.data);
          console.log(frontHostName,'Env variables ---',redirectUrl,signupUrl);
           
           if(response.data.flag == 3){
             console.log('Resend Verification link');
             this.verificationLink = true;
             return;
           }
           if (!response.data.flag) {
              this.loginFailed(response);
              return;
           }
             this.error = false;
         //  var loc =frontHostName +process.env.CAKE_BASE_PATH +wlabel +process.env.CAKE_PATH;
            //  console.log('ENV Variables --',process.env);
             var locArr = location.host.split(".");
             var topDomain = locArr[locArr.length - 1]; // Get last element from array like com, cloud, net
             var loc = location.protocol+'//'+this.account+'.'+process.env.REDIRECT_DOMAIN+'.'+topDomain;
             //console.log('Location ',loc);
             window.location.href = loc;
        })
        .catch((err) => {
             console.log('Error --',err);
             this.loginFailed() 
        });
    },
    gotoforgotpswd(){
      window.location.href="/forgot-pswd";
    },
    async resendVerificationEmail(){
      console.log('Resend Verification Email --');
      let url = process.env.API_PATH + "/resendVerificationEmailToAccountAdmin";
      await axios
        .post(
          url,
          {
            txtAccount: this.account,
            requestType: "online"
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => { 
            if (!response.data.flag) {
               this.loginFailed(response);
               return;
            }
            this.$awn.success(response.data.msg);
            this.verificationLink = false;
         }).catch((err) => { this.loginFailed() });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/LoginNew.vue